import { render, staticRenderFns } from "./textPanel.vue?vue&type=template&id=1ca43d24&scoped=true&"
import script from "./textPanel.vue?vue&type=script&lang=js&"
export * from "./textPanel.vue?vue&type=script&lang=js&"
import style0 from "./textPanel.vue?vue&type=style&index=0&id=1ca43d24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca43d24",
  null
  
)

export default component.exports